import React from 'react';
import Img from '../../Img';

import styles from './partners.module.scss';

const Partners = () => {
    const partners = [
        {
            href: 'https://www.oracle.com/',
            className: styles.oracleLogo,
            src: '/img/partners/homepage/oracle.svg',
        },
        {
            href: 'https://tennischannel.com/',
            className: styles.tennisChannelLogo,
            src: '/img/partners/homepage/tennis_channel.png',
            srcSet: '/img/partners/homepage/tennis_channel@2x.png 2x, /img/partners/homepage/tennis_channel@3x.png 3x',
        },
        {
            href: 'https://www.team8global.com/',
            className: styles.team8Logo,
            src: '/img/partners/homepage/team8.png',
            srcSet: '/img/partners/homepage/team8@2x.png 2x, /img/partners/homepage/team8@3x.png 3x',
        },
        {
            href: 'http://novakdjokovic.com/',
            className: styles.novakLogo,
            src: '/img/partners/homepage/novak-djokovic.png',
            srcSet: '/img/partners/homepage/novak-djokovic@2x.png 2x, /img/partners/homepage/novak-djokovic@3x.png 3x',
        },
        {
            href: 'https://www.tennis.com.au/',
            className: styles.nadalLogo,
            src: '/img/partners/homepage/tennis.png',
            srcSet: '/img/partners/homepage/tennis@2x.png 2x, /img/partners/homepage/tennis@3x.png 3x',
        },
        {
            href: 'https://rafanadalacademy.com/en/',
            className: styles.nadalLogo,
            src: '/img/partners/homepage/nadal.png',
            srcSet: '/img/partners/homepage/nadal@2x.png 2x, /img/partners/homepage/nadal@3x.png 3x',
        },
        {
            href: 'https://www.imgacademy.com/boarding-school/athletics/tennis',
            className: styles.imgLogo,
            src: '/img/partners/homepage/img-blue.png',
        },
        {
            href: 'https://www.mouratoglou.com/',
            className: styles.ustaLogo,
            src: '/img/partners/homepage/mouratoglou.png',
            srcSet: '',
        },
        {
            href: 'https://www.wearecollegetennis.com',
            className: styles.itaLogo,
            src: '/img/partners/homepage/ita.png',
            srcSet: '/img/partners/homepage/ita@2x.png 2x, /img/partners/homepage/ita@3x.png 3x',
        },
        {
            href: 'https://www.ptrtennis.org/',
            className: styles.ptrLogo,
            src: '/img/partners/homepage/ptr.png',
            srcSet: '/img/partners/homepage/ptr@2x.png 2x, /img/partners/homepage/ptr@3x.png 3x',
        },
        {
            href: 'https://uspta.com/',
            className: styles.usptaLogo,
            src: '/img/partners/homepage/uspta.png',
            srcSet: '/img/partners/homepage/uspta@2x.png 2x, /img/partners/homepage/uspta@3x.png 3x',
        },
        {
            href: 'https://www.usta.com',
            className: styles.ustaLogo,
            src: '/img/partners/homepage/usta.png',
        },
        {
            href: 'https://playsight.com/',
            className: styles.playSightLogo,
            src: '/img/partners/homepage/playsight.png',
        },
        {
            href: 'https://www.sanchez-casal.com/florida',
            className: styles.sanchezCasalLogo,
            src: '/img/partners/homepage/sanchez-casal.svg',
        },
        {
            href: 'https://www.pbitennis.com/',
            className: styles.pbiLogo,
            src: '/img/partners/homepage/pbi.png',
        },
    ];

    return (
        <div className={styles.partnerSection}>
            <div className="container">
                <div className={styles.content}>
                    {/* <div className={homeStyles.flavorTextUpper}>
                        The premier rating for tennis players
                    </div> */}
                    <div className={`${styles.partnerImgContainer}`}>
                        <div className="row">
                            {partners.map(partner => (
                                <div className={`${styles.partnerImgs} col-md-2`}>
                                    <picture>
                                        <a href={partner.href} target="_blank" rel="noopener noreferrer">
                                            <Img
                                                className={partner.className}
                                                src={partner.src}
                                                srcSet={partner.srcSet}
                                            />
                                        </a>
                                    </picture>
                                </div>
                            ))}

                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Partners;
